import { compose } from 'redux';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import * as overviewSavedDashboardActions from '@store/overviewDashboard/dashboard/actions';
import { initTempDashboard } from '@store/overviewDashboard/tempDashboard/actions';
import tempDashboardStateSelector from '@store/overviewDashboard/selectors';
import tempDashboardSelector from '@store/overviewDashboard/tempDashboard/selectors';
import {
  dashboardResponseSelector,
  dashboardIsFetchingSelector,
} from '@store/overviewDashboard/dashboard/selectors';
import { DASHBOARD_TYPE, PAGE_TYPE } from '@utils/constants';
import dashboard from '../../common/dashboard';
import ExperienceDashboard from '../ExperienceDashboard';
import injectorServer from '../../common/injectorServer';

const selectors = createSelector(
  dashboardResponseSelector,
  dashboardIsFetchingSelector,
  tempDashboardStateSelector,
  tempDashboardSelector,
  (response, isFetching, dashboardState, tempDashboard) => ({
    response,
    isFetching,
    dashboardType: DASHBOARD_TYPE.OVB,
    dashboard: dashboardState,
    tempIsFetching: tempDashboard.isFetching,
  }),
);

const OverviewSavedDashboard = compose(
  connect(selectors, {
    initTempDashboard,
    initDashboard: overviewSavedDashboardActions.initRequest,
    getDashboard: overviewSavedDashboardActions.getDashboard,
    fetchingAction: overviewSavedDashboardActions.fetching,
  }),
  dashboard(),
)(ExperienceDashboard);

export default injectorServer({}, { pageType: PAGE_TYPE.SAVED_DASHBOARD })(OverviewSavedDashboard);
